<template>
  <div class="mobile-warp centerContent">
    <div class="top-content">
      <img class="top-bg"
           src="../assets/img/top-bg.png"
           alt="" />
    </div>
    <div class="intr">
      <div class="content"
           @click='goLinks'>
        <img src="../assets/img/APP.png"
             class="app-img"
             alt="">
        <span class="btn-1"
              @click.stop="goLinks">官网</span>
        <!-- <img class="logo"
             src="../assets/img/logo1.png"
             alt="">
        <div class="right-content">
          <div class="line-1">
            <p class="line_t1">
              <span class="text-1">金沙娱乐 </span>
              <span class="text-2">「极致奢华,大额无忧」</span>
            </p>
            <span class="btn-1"
                  @click.stop="goLinks">官网</span>
          </div>
          <p class="line-1 line-2">
            <img v-for="index in 5"
                 :key="index"
                 class="star-1"
                 src="../assets/img/star.png"
                 alt=""
                 srcset="">
            <span class="text-3">8922万+好评</span>
          </p>
          <p class="line-1 line-3">官方直营，百万提款秒到</p>
          <p class="zcs-box">
            <img class="zcs"
                 src="../assets/img/zcs.png"
                 alt=""
                 srcset="">
          </p> 
        </div>-->
      </div>
      <div class="btn-box">
        <span @click='downLoad'><img class="btn-2"
               src="../assets/img/down-btn.png"
               alt=""></span>
        <span @click="goLinks"><img class="btn-2"
               src="../assets/img/goinfo.png"
               alt=""></span>
      </div>
      <div class="types"
           @click='goLinks'>
        <img src="../assets/img/types.png"
             alt="">
      </div>
      <div class="labels"
           @click='goLinks'>
        <p class="label-item"><img src="../assets/img/l2.png"
               alt=""><span>极速存提</span></p>
        <p class="label-item center-label"><img src="../assets/img/l1.png"
               alt=""><span>资金保障</span></p>
        <p class="label-item"><img src="../assets/img/l3.png"
               alt=""><span>分享赚钱</span></p>
      </div>

    </div>
    <img class="line"
         src="../assets/img/line.png"
         alt="">
    <div class="center-ways">
      <div class="way-top">
        <p class="left"><img src="../assets/img/inter.png"
               alt=""><span>线路中心</span></p>
        <p class="right"
           @click="showpopup=true"> <img class="r-app"
               src="../assets/img/apple1.png"
               alt=""><span>苹果下载教程</span>
          <img class="jt"
               src="../assets/img/jt.png"
               alt="">
        </p>
      </div>
      <!-- 线路检测 -->
      <div class="waysItem"
           v-for="(item, index) in currentWayList"
           :key="index"
           @click="goWay(item)">
        <div class="left">
          <span class="icon-rote"
                :class="`icon-rote${index+1}`"></span>
          <span class="label">{{item.text}}</span>
        </div>
        <img class="go-btn"
             src="../assets/img/goin.png"
             alt="">
      </div>

    </div>
    <div @click='goLinks'>
      <img class="bg-2"
           src="../assets/img/bg-2.png"
           alt="">
    </div>
    <p class="types"
       @click='goLinks'><img src="../assets/img/types1.png"
           alt=""></p>
    <!-- 热门推荐 -->
    <div class="hot-content"
         @click='goLinks'>
      <img class="hot-title"
           src="../assets/img/hot-title.png"
           alt="">
      <div class="tj">
        <img src="../assets/img/g0.png"
             alt="">
        <img src="../assets/img/g1.png"
             alt="">
        <img src="../assets/img/g2.png"
             alt="">
        <img src="../assets/img/g3.png"
             alt="">
        <img src="../assets/img/g4.png"
             alt="">
        <img src="../assets/img/g5.png"
             alt="">
        <img src="../assets/img/g6.png"
             alt="">
        <img src="../assets/img/g7.png"
             alt="">
        <img src="../assets/img/g8.png"
             alt="">
        <img src="../assets/img/g9.png"
             alt="">
        <img src="../assets/img/g10.png"
             alt="">
        <img src="../assets/img/g11.png"
             alt="">
      </div>
    </div>
    <div class="foot_box"
         @click='goLinks'>
      <img class="f-logo"
           src="../assets/img/logo.png"
           alt="">
      <div class="f-center">
        <p class="f-text-1">下载手机APP应用</p>
        <p class="f-text-2">注册即送 <span class="f-text-3">888</span>元</p>
        <p class="f-star-box">
          <img v-for="index in 5"
               :key="index"
               src="../assets/img/star1.png"
               class="f-star"
               alt="">
          <span class="f-text-4">8922万+好评</span>
        </p>
      </div>
      <span class="f-down"
            @click.stop='downLoad'>
        <img src="../assets/img/down-btn-1.png"
             alt="">
      </span>
    </div>
    <span class="service"
          @click="getService"><img src="../assets/img/service-icon.png"
           alt=""></span>
    <!-- 教程 -->
    <div class="tips-box"
         v-if="showpopup">
      <img src="../assets/img/tip-bg.png"
           class="tip-bg"
           alt="">
      <div class="close"
           @click="showpopup=false">
        <img src="../assets/img/close.png"
             alt="">
      </div>
      <div class="tip-content">
        <div class="content-title">
          <img class="apple"
               src="../assets/img/apple.png"
               alt="">
          <span class="text">苹果下载教程</span>
        </div>
        <div class="tip-item">1.点击【免费安装】</div>
        <img class="tip-img"
             src="../assets/img/tip-1.png"
             alt="">
        <div class="tip-item">2.点击【允许】</div>
        <img class="tip-img"
             src="../assets/img/tip-2.png"
             alt="">
        <div class="tip-item">3.点击【安装证书】</div>
        <img class="tip-img"
             src="../assets/img/tip-3.png"
             alt="">
        <div class="tip-item">4.点击【允许】</div>
        <img class="tip-img"
             src="../assets/img/tip-4.png"
             alt="">
        <div class="tip-item">5.点击【金沙9570】</div>
        <img class="tip-img"
             src="../assets/img/tip-5.png"
             alt="">
        <div class="tip-item">6.点击【安装】</div>
        <img class="tip-img"
             src="../assets/img/tip-6.png"
             alt="">
        <div class="tip-item">7.输入密码</div>
        <img class="tip-img"
             src="../assets/img/tip-7.png"
             alt="">
        <div class="tip-item">8.点击【安装】</div>
        <img class="tip-img"
             src="../assets/img/tip-8.png"
             alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-work',
  data () {
    return {
      showpopup: false,
      pcWayList: [
        {
          text: '线路检测1  -  8ms',
          url: 'https://eeolxf.com/#/home'
        },
        {
          text: '线路检测2  -  218ms',
          url: 'https://eexoix.com/#/home'
        },
        {
          text: '线路检测3  -  572ms',
          url: 'https://eeecgh.com/#/home'
        }
      ],
      h5WayList: [
        {
          text: '线路检测1  -  8ms',
          url: 'https://m.eeolxf.com/#/home/home-list'
        },
        {
          text: '线路检测2  -  218ms',
          url: 'https://m.eexoix.com/#/home/home-list'
        },
        {
          text: '线路检测3  -  572ms',
          url: 'https://m.eeecgh.com/#/home/home-list'
        }
      ],
      currentWayList: [],
      service_url: 'https://chat.p8bzpbi.com/#/kTc77rV4fyxVfNBD',
      agentCode: '',
      linkUrl: ''
    }
  },
  computed: {
    isIOS () {
      const userAgent = navigator.userAgent.toLowerCase()
      return /iphone ipod| ipad|macintosh|mac os x/i.test(userAgent)
    },
    isPC () {
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /iphone|ipod|android.*mobile|windows phone blackberry bada webos iemobile| opera mini ipad android Macintosh/i.test(userAgent);
      return !isMobile
    }
  },
  methods: {
    // 线路检测
    goWay () {
      this.goLinks()
      // window.open(`${data.url}/?agentCode=${this.agentCode}`)
    },
    // 客服
    getService () {
      window.open(this.service_url)
    },
    // 下载
    downLoad () {
      // let down_url = this.isIOS ? 'https://down.juboqy.com/9570/ios/' : 'https://qmrdlg.com/app-release-js3-v30.3.apk'
      // window.open(down_url, this.isIOS ? '' : '_self')
      this.goLinks()
    },
    // 访问官网
    goLinks () {
      window.open(`${this.linkUrl}/?agentCode=${this.agentCode}`)
    }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search)
    this.agentCode = params.get('agentCode')
    this.currentWayList = this.isPC ? [...this.pcWayList] : [...this.h5WayList]
    this.linkUrl = this.isPC ? 'https://www.eeolxf.com/#/register' : 'https://m.xveyrr.com/#/register'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
